export default __webpack_public_path__ + "static/media/DSC_8076.7771a281.jpg";